<template>
  <div class="single-instance-block">
    <div class="block-content">
      <div class="icon-wrapper">
        <svg class="warning-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 20h20L12 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 9v4M12 17h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <h1 class="title">{{ t('singleInstance.title') }}</h1>
      <p class="message">{{ t('singleInstance.message') }}</p>

      <div class="actions">
        <button class="btn-primary" @click="handleCloseWindow">
          {{ t('singleInstance.closeWindow') }}
        </button>
      </div>

      <p class="hint">{{ t('singleInstance.hint') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

function handleCloseWindow() {
  window.close()
}
</script>

<style scoped lang="scss">
.single-instance-block {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  color: #ffffff;
  font-family: 'Lato', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  z-index: 9999;
}

.block-content {
  max-width: 500px;
  padding: 48px 32px;
  text-align: center;
  animation: fadeIn 0.3s ease-in;
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.warning-icon {
  width: 80px;
  height: 80px;
  color: #fbbf24;
  filter: drop-shadow(0 4px 12px rgba(251, 191, 36, 0.3));
  animation: pulse 2s ease-in-out infinite;
}

.title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: #ffffff;
}

.message {
  font-size: 16px;
  line-height: 1.6;
  color: #a3a3a3;
  margin: 0 0 32px 0;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.btn-primary {
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  background: #3b82f6;
  color: #ffffff;

  &:hover {
    background: #2563eb;
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
}

.hint {
  font-size: 13px;
  color: #737373;
  margin: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>
